import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 14, className = "", title = "Cuenta verificada" }) {
  return (
    <span
      title={title}
      aria-label={title}
      className={`inline-flex items-center text-blue-400 ${className}`}
      style={{ verticalAlign: "middle" }}
    >
      <BadgeCheck size={size} fill="#1d9bf0" stroke="#0b1220" strokeWidth={2.2} />
    </span>
  );
}
